export enum PRODUCT {
  NA = -1,
  UNLIMITED = 0,
  PRO = 1,
  BASIC = 2,
  FREE = 3,
}

export enum CYCLE {
  DOUBlE_YEAR = 0,
  SINGLE_YEAR = 1,
  SINGLE_MONTH = 2,
}
